var React = require('react');

function ProductsInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 0C1.40991 22.8954 19.2274 40.9994 41 40.9994C62.7726 40.9994 80.5901 22.8954 82 0H0Z","fill":"#FAA8C0"}));
}

ProductsInline.defaultProps = {"width":"82","height":"41","viewBox":"0 0 82 41","fill":"none"};

module.exports = ProductsInline;

ProductsInline.default = ProductsInline;
